/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Header from "./header"
import BurgerMenu from "./burger_menu"
import Footer from "./footer"
import Chat from '../components/chat/_chat'
// import Modal from "./modal/modal"
import Video from "./video/video"
import { pushToDataLayer } from './gtm/pushDataLayer'
import { createDlStartEvent } from '../utils/gtm/dlStart'

const Layout = ({ children, _class = '', chat = true, header_visible = false, productInfo = null }) => {
  const [isMenuModels, setIsMenuModels] = useState(false);
  // const [modalOpen, setModalOpen] = useState(false)
  // const [modalShownInSession, setModalShownInSession] = useState(false)

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  function handleMenuModels(isMenuModelActive) {
    setIsMenuModels(isMenuModelActive)
  }

  // Push dl_start event al cargar la página
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const pathname = window.location.pathname;
      const dlStartEvent = createDlStartEvent(pathname, productInfo);
      pushToDataLayer(dlStartEvent);
    }
  }, []); // Solo ejecutar una vez al montar

  // useEffect(() => {
  //   // Verificar si el modal ya se mostró en esta sesión
  //   // const modalShownInThisSession = sessionStorage.getItem('modalShownInSession');

  //   // Si no se ha mostrado en esta sesión, mostrarlo
  //   if (!modalShownInThisSession && !modalShownInSession) {
  //     setModalOpen(true);
  //     setModalShownInSession(true);
  //     // Marcar en sessionStorage que ya se mostró en esta sesión
  //     sessionStorage.setItem('modalShownInSession', 'true');
  //   }
  // }, [modalShownInSession]);

  // const closeModal = () => {
  //   setModalOpen(false);
  // };

  return (
    <>
      {chat ? <Chat /> : null}
      <BurgerMenu isMenuModels={isMenuModels} />
      <Header handleMenuModels={handleMenuModels} siteTitle={data.site.siteMetadata.title} header_visible={header_visible} />
      <div className="stage">
        <div className={`main ${_class}`}>{children}</div>
      </div>
      <Footer />
      {
        // modalOpen && <Modal closeModalHandler={closeModal} >
        //   <Video url="https://www.youtube.com/watch?v=CJVabFOmtJs" />
        // </Modal>
      }
      <div id="modal-root" />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
